import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  public env = environment;

  constructor(public _common: CommonService,
    public _shared: SharedService) { }

  ngOnInit(): void {
  }

  openLogin() {
    this._shared.emitLoginModal({ 'login': true });
  }

}
